<div class="header-bar">
  <h1>User Management Report</h1>
</div>
<div class="">
  <div class="content-container">
    <div class="card card-w-title" style="position: relative">
      <div class="subtitle" *ngIf="isLoaded">{{ this.page.total }} users</div>
      <div class="subtitle" *ngIf="!isLoaded">Loading...</div>
    </div>

    <form (ngSubmit)="search()">
      <div class="ui-g filterPanel">
        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <p-multiSelect
            name="customers"
            [options]="customers"
            [(ngModel)]="filterVal.filters.organisationIds.value"
            styleClass="filterItem"
            [style]="{ width: '100%' }"
            (ngModelChange)="customerSelect()"
            defaultLabel="Customers"
          ></p-multiSelect>
        </div>

        <div class="ui-g-12 ui-md-3 ui-lg-3">
          <p-multiSelect
            [disabled]="!departments || departments.length == 0"
            name="departments"
            [options]="departments"
            [(ngModel)]="filterVal.filters.departmentIds.value"
            styleClass="filterItem"
            [style]="{ width: '100%' }"
            defaultLabel="Departments"
          ></p-multiSelect>
        </div>

        <div class="ui-g-12 ui-md-2 ui-lg-2" style="margin-top: auto; margin-bottom: auto">
          <p-triStateCheckbox
            name="active"
            [(ngModel)]="activeState"
            (ngModelChange)="activeStateChanged()"
          ></p-triStateCheckbox>
          Active?
        </div>

        <div class="ui-g-12 ui-md-4 ui-lg-4" style="text-align: right">
          <button pButton type="submit" label="Search" icon="fa ui-icon-search"></button>
          <button
            pButton
            type="button"
            label="Clear"
            icon="fa ui-icon-close"
            (click)="clearFilter()"
          ></button>
          <button
            type="button"
            pButton
            (click)="exportCSV()"
            [disabled]="csvDownloading"
            pTooltip="Download user report to CSV"
            tooltipPosition="left"
          >
            <span class="chart-loading button-text" *ngIf="csvDownloading"
              ><i class="fa fa-spinner fa-spin"></i>&nbsp; Downloading CSV...</span
            >
            <span *ngIf="!csvDownloading" class="button-text">
              <i class="fa fa-cloud-download"></i> Export To CSV</span
            >
          </button>
        </div>
      </div>
    </form>

    <p-table
      #dt
      [value]="page.items"
      [lazy]="true"
      [rows]="20"
      [responsive]="true"
      [paginator]="true"
      rowHover="true"
      resizableColumns="true"
      [first]="filterVal.first"
      [totalRecords]="page.total"
      (onLazyLoad)="onGridLazyLoad($event)"
      [hidden]="!isLoaded"
      [rowsPerPageOptions]="[20, 30, 50, 100]"
      [pageLinks]="7"
      selectionMode="single"
      [sortField]="filterVal.sortField"
      [sortOrder]="filterVal.sortOrder"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="userName">User Name</th>
          <th pSortableColumn="firstLogin">First Login</th>
          <th pSortableColumn="lastLogin">Last Login</th>
          <th pSortableColumn="ordersPlaced"># Orders</th>
          <th pSortableColumn="lastOrderPlaces">Last Order Date</th>
          <th pSortableColumn="roles">Roles</th>
          <th pSortableColumn="organisationName">Org.Name</th>
          <th>Dept.Names</th>
          <th>Team Names</th>
          <th pSortableColumn="active">Active</th>
          <th pSortableColumn="createdDateTime">Created</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr [pSelectableRow]="item">
          <td>{{ item.userName }}</td>
          <td>
            <div>
              {{ item.firstLogin | datex : 'DD MMM YYYY' }}
            </div>
          </td>
          <td>
            <div>
              {{ item.lastLogin | datex : 'DD MMM YYYY' }}
            </div>
          </td>
          <td>{{ item.ordersPlaced }}</td>
          <td>{{ item.lastOrderPlaced | datex : 'DD MMM YYYY' }}</td>
          <td>
            <div [pTooltip]="item.roles">
              {{ item.roles }}
            </div>
          </td>
          <td>{{ item.organisationName }}</td>
          <td>{{ item.departmentNames }}</td>
          <td>{{ item.teamNames }}</td>
          <td>
            <div>
              {{ item.active ? 'Yes' : 'No' }}
            </div>
          </td>
          <td>
            <div>
              {{ item.createdDateTime | datex : 'DD MMM YY HH:mm' }}
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- DATATABLE DEPRECATED ---
    <p-dataTabl #dt [value]="page.items" [lazy]="true" [rows]="20" [responsive]="true" [paginator]="true" rowHover="true"
                 resizableColumns="true" [first]="filterVal.first" [totalRecords]="page.total" (onLazyLoad)="onGridLazyLoad($event)"
                 [hidden]="!isLoaded" [rowsPerPageOptions]="[20,30,50,100]" [pageLinks]="7"
                 selectionMode="single" [sortField]="filterVal.sortField" [sortOrder]="filterVal.sortOrder">

      <p-column field="userName" header="User Name" [sortable]="tru" [style]="{'width' : 'auto'}"></p-column>
      
      <p-column field="firstLogin" header="First Login" [sortable]="tru" [style]="{'width' : '110px'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <div>
            {{ item[col.field] | datex:'DD MMM YYYY' }}
          </div>
        </ng-template>
      </p-column>
      <p-column field="lastLogin" header="Last Login" [sortable]="tru" [style]="{'width' : '110px'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <div>
            {{ item[col.field] | datex:'DD MMM YYYY' }}
          </div>
        </ng-template>
      </p-column>

      <p-column field="ordersPlaced" header="# Orders" [sortable]="tru" styleClass="align-center" [style]="{'width': '90px'}">
      </p-column>

      <p-column field="lastOrderPlaced" header="Last Order Date" [sortable]="tru" [style]="{'width' : '130px'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <div>
            {{ item[col.field] | datex:'DD MMM YYYY' }}
          </div>
        </ng-template>
      </p-column>

      <p-column field="roles" header="Roles" [sortable]="false" [style]="{'width' : 'auto'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <div [pTooltip]="item[col.field]">
            {{ item[col.field] }}
          </div>
        </ng-template>
      </p-column>

      <p-column field="organisationName" header="Org. Name" [sortable]="tru" [style]="{'width' : 'auto'}"></p-column>

      <p-column field="departmentName" header="Dept. Name" [sortable]="tru" [style]="{'width' : 'auto'}"></p-column>

      <p-column field="teamName" header="Team Name" [sortable]="tru" [style]="{'width' : 'auto'}"></p-column>

      <p-column field="active" header="Active" [sortable]="tru" styleClass="align-center" [style]="{'width' : '85px'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <div>
            {{ item[col.field] ? 'Yes' : 'No' }}
          </div>
        </ng-template>
      </p-column>
      <p-column field="createdDateTime" header="Created Date" [sortable]="tru" [style]="{'width' : '130px'}">
        <ng-template let-col let-item="rowData" pTemplate="body">
          <div>
            {{ item[col.field] |datex:'DD MMM YY HH:mm' }}
          </div>
        </ng-template>
      </p-column>
    </p-dataTable>

    -->
  </div>
</div>
